import { init } from '@plausible-analytics/tracker'

init({
    domain: 'ww6-fmovies.com',
    endpoint: 'https://pb.ytmp3tube.com/api/event'
})